<template>
  <div class="landing" :class="{ 'theme-dark': dark }">
    <!-- ===================== NAV ===================== -->
    <header>
      <div class="wrap nav">
        <div class="brand">
          <span class="logo">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a7 7 0 0 0-7 7c0 2 1 3.5 1 5a3 3 0 0 0 6 0 3 3 0 0 0 6 0c0-1.5 1-3 1-5a7 7 0 0 0-7-7Z"/><path d="M9 13a3 3 0 0 1 6 0"/></svg>
          </span>
          Zeno
        </div>
        <nav class="nav-links">
          <a href="#method">心流方法</a>
          <a href="#features">功能</a>
          <a href="#profiles">任务模式</a>
          <a href="#platforms">多端</a>
          <a href="#pricing">定价</a>
        </nav>
        <div class="nav-cta">
          <button
            class="theme-toggle"
            @click="toggleDark"
            :title="dark ? '切换浅色' : '切换深色'"
            aria-label="切换深浅主题"
          >
            <svg v-if="dark" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
            <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z"/></svg>
          </button>
          <router-link to="/app" class="btn btn-primary">免费开始</router-link>
        </div>
      </div>
    </header>

    <!-- ===================== HERO ===================== -->
    <section class="hero">
      <div class="hero-glow"></div>
      <div class="wrap hero-grid">
        <div>
          <span class="eyebrow"><span class="dot"></span>基于神经科学的专注法</span>
          <h1 class="grad-text">专注当下，<br/>心流不止。</h1>
          <p class="lead">Zeno 是一款为「深度专注」而生的计时器。用心流提示音、任务节奏与 90/20 循环，帮你更快进入心流，并把每一段专注沉淀成可见的成长。</p>
          <div class="hero-cta">
            <router-link to="/app" class="btn btn-primary">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
              立即免费体验
            </router-link>
            <a href="#method" class="btn btn-ghost">了解心流方法</a>
          </div>
          <div class="hero-meta">
            <div class="m"><b>3–5min</b><span>随机微休息节奏</span></div>
            <div class="m"><b>90 / 20</b><span>深度专注大循环</span></div>
            <div class="m"><b>3 端 · 3 语</b><span>桌面 / 手机 / 网页</span></div>
          </div>
        </div>

        <!-- phone mockup：还原真实计时器主界面（月白主题） -->
        <div style="position:relative">
          <div class="phone">
            <div class="glow"></div>
            <div class="top">
              <span class="top-ic">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </span>
              <span class="top-brand">Zeno</span>
              <span class="top-ic">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a7 7 0 0 0-7 7c0 2 1 3.5 1 5a3 3 0 0 0 6 0 3 3 0 0 0 6 0c0-1.5 1-3 1-5a7 7 0 0 0-7-7Z"/><path d="M9 13a3 3 0 0 1 6 0"/></svg>
              </span>
            </div>
            <div class="timer">
              <div class="num">25:00</div>
              <button class="tag-pill">记忆背诵</button>
            </div>
            <div class="controls">
              <span class="start-btn">开始</span>
            </div>
          </div>
          <!-- floating cards -->
          <div class="float-card fc-1">
            <span class="ic ic-emerald"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z"/><path d="M9 12a3 3 0 0 0 6 0"/></svg></span>
            <div><b>闭眼微休息</b><span>10 秒 · 神经重放</span></div>
          </div>
          <div class="float-card fc-2">
            <span class="ic ic-amber"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17l5-5 4 4 8-8"/><path d="M16 8h5v5"/></svg></span>
            <div><b>连续 7 天</b><span>专注 12h 30m</span></div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== STRIP ===================== -->
    <section class="strip">
      <div class="wrap row">
        <span class="strip-lead">为这些时刻而生 ——</span>
        <span class="pf">📚 备考刷题</span>
        <span class="pf">💻 编程开发</span>
        <span class="pf">✍️ 写作创作</span>
        <span class="pf">🎹 技能练习</span>
        <span class="pf">🧠 深度阅读</span>
      </div>
    </section>

    <!-- ===================== METHOD BAND ===================== -->
    <section class="pad" id="method">
      <div class="wrap band">
        <div>
          <span class="eyebrow"><span class="dot"></span>核心方法 · 心流提示音</span>
          <h3>每隔几分钟，<span class="grad-text">轻轻提醒你闭眼 10 秒</span></h3>
          <p>在专注过程中，Zeno 会按你设定的随机间隔（如 3–5 分钟）响起一声轻提示。这一刻闭眼微休息，让大脑高速「重放」刚刚学到的内容——这正是神经科学中巩固记忆的关键窗口。</p>
          <ul class="ticks">
            <li><span class="tk">✓</span><span>随机间隔触发，避免大脑预期、保持新鲜度</span></li>
            <li><span class="tk">✓</span><span>提示音 + 震动 + 系统通知，分心也不会错过</span></li>
            <li><span class="tk">✓</span><span>10 秒倒计时微休息，结束自动提醒睁眼继续</span></li>
            <li><span class="tk">✓</span><span>默认开启、运行中可随时开关，即时生效</span></li>
          </ul>
        </div>
        <div class="band-media">
          <div class="media-card">
            <div class="mglow"></div>
            <div class="rest-demo">
              <div class="rest-circle">
                <div class="rest-ring"></div>
                <div class="cd">10</div>
              </div>
              <div style="text-align:center">
                <div class="lbl">闭眼休息 · 大脑正在重放</div>
                <div class="sub">10 秒后自动回到专注</div>
              </div>
              <div class="timeline">
                <span class="seg work"></span><span class="ping"></span>
                <span class="seg work"></span><span class="ping"></span>
                <span class="seg work"></span><span class="ping"></span>
                <span class="seg work"></span>
              </div>
              <div class="sub">每段专注中随机插入微休息</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== FEATURE GRID ===================== -->
    <section class="pad alt" id="features">
      <div class="wrap">
        <div class="sec-head">
          <span class="eyebrow"><span class="dot"></span>完整功能</span>
          <h2>专注所需的一切，<span class="grad-text">克制而完整</span></h2>
          <p>没有花哨的游戏化，只有真正帮你进入并维持专注的工具。</p>
        </div>
        <div class="grid">
          <div class="card">
            <div class="ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 3 0 1 0 18 0 9 3 0 1 0-18 0"/><path d="m9 12 2 2 4-4"/></svg></div>
            <h4>心流提示音</h4>
            <p>基于神经重放的随机微休息，巩固记忆、对抗疲劳，是 Zeno 的方法内核，免费完整可用。</p>
          </div>
          <div class="card">
            <div class="ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 6v6l4 2"/><circle cx="12" cy="12" r="9"/></svg></div>
            <h4>无限正计时 & 倒计时</h4>
            <p>15–90 分钟六档预设，支持自定义时长与 ∞ 无限正计时；九类任务标签可自建，开始即专注。</p>
          </div>
          <div class="card">
            <div class="ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4v16M4 4h12l-2 4 2 4H4"/></svg></div>
            <h4>90 / 20 大循环</h4>
            <p>90 分钟深度专注、20 分钟充分休息，自动衔接循环往复，贴合超日节律，长时间学习不崩。</p>
          </div>
          <div class="card">
            <div class="ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg></div>
            <h4>心流热力图</h4>
            <p>整月热力图按当日心流时长着色，点任意日期回看当天每一条专注记录与连续打卡。</p>
          </div>
          <div class="card">
            <div class="ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg></div>
            <h4>分享成绩单</h4>
            <p>一键生成精美成绩单卡片，今日 / 本周 / 累计三张随心切换，保存图片分享你的坚持。</p>
          </div>
          <div class="card">
            <div class="ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="14" rx="2"/><path d="M8 21h8M12 18v3"/></svg></div>
            <h4>跨设备接力</h4>
            <p>桌面、手机、网页无缝接力，换设备一键继续刚才那段专注，剩余时间与设置原样带走。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== PROFILES ===================== -->
    <section class="pad" id="profiles">
      <div class="wrap">
        <div class="sec-head">
          <span class="eyebrow"><span class="dot"></span>任务模式</span>
          <h2>按任务类型选节奏，<span class="grad-text">而非无差别打断</span></h2>
          <p>不同的工作需要不同的节奏。Zeno 把方法拆成三种模式，诚实地告诉你哪种任务最适合微休息。</p>
        </div>
        <div class="profiles">
          <div class="pf-card">
            <span class="tagk strong">证据较强</span>
            <h4>记忆背诵</h4>
            <p>3–5 分钟随机微休息，利用神经重放强化记忆。背单词、记知识点最适合。</p>
            <div class="rng">随机间隔 3–5 分钟</div>
          </div>
          <div class="pf-card">
            <span class="tagk soft">适合穿插</span>
            <h4>技能练习</h4>
            <p>4–6 分钟随机微休息，在练习回合之间巩固动作序列。乐器、运动、编程练习。</p>
            <div class="rng">随机间隔 4–6 分钟</div>
          </div>
          <div class="pf-card">
            <span class="tagk counter">低频 · 可关</span>
            <h4>深度工作</h4>
            <p>默认 4–6 分钟低频心流提示音，叠加 90/20 大循环；写作、长链推理想全程沉浸时可一键关闭。</p>
            <div class="rng">随机间隔 4–6 分钟 · 90/20 循环</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== DATA / SHARE ===================== -->
    <section class="pad alt">
      <div class="wrap band rev">
        <div>
          <span class="eyebrow"><span class="dot"></span>看得见的成长</span>
          <h3>每一段专注，<span class="grad-text">都被认真记录</span></h3>
          <p>Zeno 把你的专注沉淀成数据：今日时长、连续打卡、累计成就，再用一张热力图把坚持可视化。想分享时，一键生成精美成绩单。</p>
          <div class="stat-row">
            <div class="s"><b>128h</b><span>累计专注</span></div>
            <div class="s"><b>23 天</b><span>连续打卡</span></div>
            <div class="s"><b>342</b><span>完成次数</span></div>
          </div>
          <div style="margin-top:26px">
            <div class="heat">
              <div
                v-for="(lv, i) in heatCells"
                :key="i"
                class="cell"
                :style="lv > 0 ? { background: 'rgba(217,119,6,' + (0.16 + lv * 0.16) + ')' } : {}"
              ></div>
            </div>
          </div>
        </div>
        <div class="band-media">
          <div class="media-card">
            <div class="mglow"></div>
            <div class="share-mini">
              <div class="sglow"></div>
              <div class="zn">Z E N O</div>
              <div class="slo">专注当下，心流不止</div>
              <div class="big">1h 10m</div>
              <div class="biglbl">今日心流</div>
              <div class="mini-rows">
                <div class="r"><span>记忆背诵 · 09:30</span><b>+25m</b></div>
                <div class="r"><span>深度阅读 · 11:05</span><b>+45m</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== PLATFORMS ===================== -->
    <section class="pad" id="platforms">
      <div class="wrap">
        <div class="sec-head">
          <span class="eyebrow"><span class="dot"></span>随处可用</span>
          <h2>一份专注，<span class="grad-text">跨越所有设备</span></h2>
          <p>桌面端、移动端、网页端原生体验，三语界面，专注接力随时延续。</p>
        </div>
        <div class="plats">
          <div class="plat">
            <div class="pic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg></div>
            <b>桌面端</b>
            <span>macOS · Windows<br/>菜单栏实时倒计时</span>
          </div>
          <div class="plat">
            <div class="pic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="2.5"/><path d="M11 18h2"/></svg></div>
            <b>移动端</b>
            <span>iOS · Android<br/>震动与通知提醒</span>
          </div>
          <div class="plat">
            <div class="pic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20"/></svg></div>
            <b>网页端</b>
            <span>免安装<br/>打开即用</span>
          </div>
          <div class="plat">
            <div class="pic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8l-3 9h20l-3-9"/><path d="M8 8a4 4 0 0 1 8 0"/><circle cx="12" cy="5" r="2"/></svg></div>
            <b>三语 · 16 款主题</b>
            <span>简 / 繁 / 英<br/>五行 · 东方 · 西学</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== PRICING ===================== -->
    <section class="pad" id="pricing">
      <div class="wrap">
        <div class="sec-head">
          <span class="eyebrow"><span class="dot"></span>定价</span>
          <h2>选你需要的，<span class="grad-text">从工具到改变</span></h2>
          <p>方法内核永久免费；想要更多主题与云同步可升级 Pro；想要被带着系统改变，加入「一念」30 天训练营。</p>
        </div>
        <div class="price-wrap">
          <div class="price">
            <span class="badge">免费版</span>
            <div class="pp">¥0</div>
            <div class="psub">方法内核完整可用</div>
            <ul>
              <li><span class="tk">✓</span>心流提示音 · 闭眼微休息</li>
              <li><span class="tk">✓</span>全部计时：预设 / 自定义 / ∞ / 90·20</li>
              <li><span class="tk">✓</span>任务模式 · 心流热力图 · 统计</li>
              <li><span class="tk">✓</span>分享成绩单</li>
            </ul>
            <router-link to="/app" class="btn btn-ghost btn-block">免费开始</router-link>
          </div>
          <div class="price">
            <span class="badge">买断 · 立省 30%</span>
            <div class="pname">Zeno Pro</div>
            <div class="pp">¥198 <small>/ 永久</small></div>
            <div class="psub">一次买断，终身畅享；也支持月度 / 年度订阅</div>
            <ul>
              <li><span class="tk">✓</span>免费版全部功能</li>
              <li><span class="tk">✓</span>16 款主题全解锁（五行 · 东方 · 西学）</li>
              <li><span class="tk">✓</span>高级提示音效（水晶 · 磬音 · 古琴）</li>
              <li><span class="tk">✓</span>数据云同步 · 多设备实时备份</li>
            </ul>
            <router-link to="/app" class="btn btn-ghost btn-block">立即开通 Pro</router-link>
          </div>
          <div class="price pro">
            <span class="ribbon">旗舰 · 限额</span>
            <div class="pname">一念 · 30 天训练营</div>
            <div class="pp">¥598</div>
            <div class="psub">软件 Pro + 30 天专注训练营</div>
            <ul>
              <li><span class="tk">✓</span>包含 Zeno Pro 全部权益（永久）</li>
              <li><span class="tk">✓</span>30 天结构化专注训练计划</li>
              <li><span class="tk">✓</span>每日任务 · 社群打卡 · 教练答疑</li>
              <li><span class="tk">✓</span>专注复盘报告 + 结营证书</li>
            </ul>
            <router-link to="/app" class="btn btn-primary btn-block">加入训练营</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== FINAL CTA ===================== -->
    <section class="pad" id="download">
      <div class="wrap">
        <div class="cta-final">
          <div class="cglow"></div>
          <h2 class="grad-text" style="position:relative">现在，开始你的第一段心流。</h2>
          <p>无需注册，打开即专注。把每一段认真投入，都变成看得见的成长。</p>
          <div class="cta-btns">
            <router-link to="/app" class="btn btn-primary">网页端直接体验</router-link>
            <a href="#platforms" class="btn btn-ghost">了解桌面 / 移动端</a>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================== FOOTER ===================== -->
    <footer>
      <div class="wrap">
        <div class="foot">
          <div class="col brand-col">
            <div class="brand" style="margin-bottom:6px">
              <span class="logo"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a7 7 0 0 0-7 7c0 2 1 3.5 1 5a3 3 0 0 0 6 0 3 3 0 0 0 6 0c0-1.5 1-3 1-5a7 7 0 0 0-7-7Z"/><path d="M9 13a3 3 0 0 1 6 0"/></svg></span>
              Zeno
            </div>
            <span class="brand-desc">专注当下，心流不止。一款基于神经科学的心流专注计时器。</span>
          </div>
          <div class="col">
            <span class="ht">产品</span>
            <a href="#method">心流方法</a>
            <a href="#features">功能</a>
            <a href="#profiles">任务模式</a>
            <a href="#pricing">定价</a>
          </div>
          <div class="col">
            <span class="ht">平台</span>
            <router-link to="/app">网页端</router-link>
            <a href="#platforms">桌面端</a>
            <a href="#platforms">移动端</a>
          </div>
          <div class="col">
            <span class="ht">关于</span>
            <a href="#">用户协议</a>
            <a href="#">隐私政策</a>
            <a href="#">联系我们</a>
          </div>
        </div>
        <div class="copyright">
          <span>© 2026 Zeno. All rights reserved.</span>
          <span>Made for deep focus.</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    // 深/浅主页：优先用户上次的选择，否则跟随系统偏好，
    // 从而「保留」原来的暗色首页——深色偏好用户默认看到暗色版。
    const stored = localStorage.getItem("zeno_landing_dark");
    const dark =
      stored !== null
        ? stored === "true"
        : !!(
            window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
          );
    return {
      dark,
      // 35 天热力图强度（0–5），纯展示
      heatCells: [
        0, 1, 2, 4, 1, 0, 3, 2, 4, 3, 1, 0, 2, 5, 1, 3, 5, 4, 2, 1, 0, 4, 3,
        2, 5, 4, 3, 2, 1, 0, 2, 3, 4, 5, 3,
      ],
    };
  },
  watch: {
    dark(v) {
      localStorage.setItem("zeno_landing_dark", String(v));
    },
  },
  methods: {
    toggleDark() {
      this.dark = !this.dark;
    },
  },
  mounted() {
    document.title = "Zeno · 专注当下，心流不止";
  },
};
</script>

<style scoped>
/* ===== 设计令牌：与计时器默认主题「金·月白」一致 =====
   bg #eef2f5 / 卡片 145deg #ffffff→#dbe4ef / 边框 #cbd5e1 / 墨色 #1e293b
   主按钮石板灰 #64748b 全圆角（同 App「开始」按钮）；
   琥珀仅用于 Pro 与数据（同 App 热力图/会员横幅）；翠绿用于微休息。 */
.landing {
  --bg: #eef2f5;
  --card: linear-gradient(145deg, #ffffff, #dbe4ef);
  --brd: #cbd5e1;
  --ink: #1e293b;
  --muted: rgba(30, 41, 59, 0.64);
  --faint: rgba(30, 41, 59, 0.42);
  --slate: #64748b;
  --slate-deep: #475569;
  --slate-soft: rgba(100, 116, 139, 0.12);
  --amber: #f59e0b;
  --amber-lt: #fbbf24;
  --amber-deep: #d97706;
  --amber-soft: rgba(245, 158, 11, 0.12);
  --emerald: #059669;
  --radius: 22px;
  --maxw: 1160px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui,
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Roboto, Helvetica,
    Arial, sans-serif;
  background: var(--bg);
  color: var(--ink);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
  text-align: left;
  min-height: 100vh;
}
.landing *,
.landing *::before,
.landing *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.landing a {
  color: inherit;
  text-decoration: none;
}
.landing svg {
  display: block;
}
.wrap {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 0 24px;
}
section {
  position: relative;
}
.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--slate-deep);
  padding: 7px 14px;
  border-radius: 999px;
  background: var(--slate-soft);
  border: 1px solid rgba(100, 116, 139, 0.28);
}
.eyebrow .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--slate);
  box-shadow: 0 0 10px rgba(100, 116, 139, 0.7);
}
h1, h2, h3 {
  letter-spacing: -0.02em;
  line-height: 1.1;
  font-weight: 800;
}
.grad-text {
  background: linear-gradient(120deg, #0f172a 20%, var(--slate) 75%, #94a3b8);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.btn {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  border: none;
  padding: 13px 26px;
  border-radius: 999px; /* 与 App 按钮一致的全圆角胶囊 */
  transition: transform 0.15s ease, box-shadow 0.25s ease, background 0.2s ease;
}
/* 背景保持原版石板灰；文字修正为真正的白色——
   此前 `.landing a { color: inherit }`(0,1,1) 优先级高于 `.btn-primary`(0,1,0)，
   把 CTA 链接的文字压成了深墨色，灰底深字发糊。
   用 .btn.btn-primary(0,2,0) 提升优先级，让白字实际生效。 */
.btn.btn-primary {
  background: var(--slate);
  color: #fff;
  letter-spacing: 0.02em;
  box-shadow: 0 10px 26px -8px rgba(71, 85, 105, 0.55);
}
.btn.btn-primary:hover {
  background: var(--slate-deep);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 16px 36px -8px rgba(71, 85, 105, 0.6);
}
.btn-ghost {
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--brd);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
}
.btn-ghost:hover {
  background: #f8fafc;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}
.btn-block {
  width: 100%;
  justify-content: center;
}

/* ---------- NAV ---------- */
header {
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(14px);
  background: rgba(238, 242, 245, 0.78);
  border-bottom: 1px solid rgba(15, 23, 42, 0.07);
}
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 66px;
}
.brand {
  display: flex;
  align-items: center;
  gap: 11px;
  font-weight: 800;
  font-size: 19px;
  letter-spacing: 0.02em;
}
.logo {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: var(--card);
  border: 1px solid var(--brd);
  box-shadow: 0 4px 14px -4px rgba(71, 85, 105, 0.4);
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 30px;
}
.nav-links a {
  font-size: 14.5px;
  color: var(--muted);
  font-weight: 600;
  transition: color 0.2s;
}
.nav-links a:hover {
  color: var(--ink);
}
.nav-cta {
  display: flex;
  align-items: center;
  gap: 14px;
}
@media (max-width: 860px) {
  .nav-links {
    display: none;
  }
}

/* ---------- HERO ---------- */
.hero {
  padding: 84px 0 60px;
  overflow: hidden;
}
.hero-glow {
  position: absolute;
  top: -200px;
  left: 50%;
  transform: translateX(-50%);
  width: 900px;
  height: 600px;
  background: radial-gradient(
    closest-side,
    rgba(100, 116, 139, 0.16),
    rgba(100, 116, 139, 0)
  );
  pointer-events: none;
}
.hero-grid {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 50px;
  align-items: center;
  position: relative;
}
.hero h1 {
  font-size: clamp(40px, 6vw, 64px);
  margin: 22px 0 20px;
}
.hero p.lead {
  font-size: clamp(16px, 2.1vw, 19px);
  color: var(--muted);
  max-width: 30em;
  margin-bottom: 30px;
}
.hero-cta {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}
.hero-meta {
  display: flex;
  gap: 26px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.hero-meta .m {
  display: flex;
  flex-direction: column;
}
.hero-meta .m b {
  font-size: 24px;
  font-weight: 800;
  color: var(--slate-deep);
}
.hero-meta .m span {
  font-size: 12.5px;
  color: var(--faint);
  font-weight: 600;
}
@media (max-width: 880px) {
  .hero-grid {
    grid-template-columns: 1fr;
    gap: 44px;
  }
  .hero {
    padding: 54px 0 40px;
  }
}

/* ---------- phone mockup：真实 App 主界面（月白） ---------- */
.phone {
  position: relative;
  width: 300px;
  margin: 0 auto;
  aspect-ratio: 300/620;
  border-radius: 42px;
  background: var(--card);
  border: 1px solid var(--brd);
  box-shadow: 0 40px 80px -28px rgba(30, 41, 59, 0.4),
    0 0 0 6px rgba(255, 255, 255, 0.5),
    inset 0 0 0 1px rgba(255, 255, 255, 0.6);
  padding: 26px 22px 30px;
  display: flex;
  flex-direction: column;
}
.phone .glow {
  position: absolute;
  top: -4%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 34%;
  background: radial-gradient(
    closest-side,
    rgba(100, 116, 139, 0.14),
    transparent
  );
  pointer-events: none;
}
.phone .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.phone .top-brand {
  font-size: 14px;
  font-weight: 700;
  color: var(--faint);
  letter-spacing: 0.02em;
}
.phone .top-ic {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: rgba(30, 41, 59, 0.45);
  background: rgba(15, 23, 42, 0.04);
}
.phone .timer {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
}
.phone .num {
  font-size: 64px;
  font-weight: 900;
  letter-spacing: -0.02em;
  color: var(--ink);
  font-feature-settings: "tnum" on;
  line-height: 1;
}
.phone .tag-pill {
  font-size: 14px;
  font-weight: 500;
  color: var(--muted);
  padding: 6px 18px;
  border-radius: 999px;
  border: 1px solid rgba(30, 41, 59, 0.18);
  background: transparent;
  cursor: default;
  font-family: inherit;
}
.phone .controls {
  display: flex;
  justify-content: center;
  padding-bottom: 6px;
}
.phone .start-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 15px 48px;
  border-radius: 999px;
  /* 手机模型是计时器示意图，按钮沿用 App 月白主题原色 #64748b（勿动） */
  background: var(--slate);
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.08em;
  box-shadow: 0 14px 30px -10px rgba(71, 85, 105, 0.55);
}
.float-card {
  position: absolute;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  border: 1px solid var(--brd);
  border-radius: 14px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 18px 36px -14px rgba(30, 41, 59, 0.3);
}
.float-card .ic {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  flex: none;
}
.float-card .ic-emerald {
  background: rgba(5, 150, 105, 0.12);
  color: var(--emerald);
}
.float-card .ic-amber {
  background: var(--amber-soft);
  color: var(--amber-deep);
}
.float-card b {
  font-size: 13.5px;
  display: block;
  color: var(--ink);
}
.float-card span {
  font-size: 11.5px;
  color: var(--faint);
}
.fc-1 {
  top: 18%;
  left: -42px;
}
.fc-2 {
  bottom: 14%;
  right: -46px;
}
@media (max-width: 880px) {
  .fc-1 {
    left: -14px;
  }
  .fc-2 {
    right: -12px;
  }
}

/* ---------- logos strip ---------- */
.strip {
  padding: 26px 0;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}
.strip .row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 38px;
  flex-wrap: wrap;
  color: var(--faint);
  font-weight: 700;
  font-size: 14px;
}
.strip-lead {
  color: var(--faint);
  font-size: 13px;
  letter-spacing: 0.05em;
}
.strip .pf {
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.85;
}

/* ---------- section heading ---------- */
.sec-head {
  text-align: center;
  max-width: 680px;
  margin: 0 auto 54px;
}
.sec-head h2 {
  font-size: clamp(28px, 4vw, 42px);
  margin: 18px 0 14px;
}
.sec-head p {
  color: var(--muted);
  font-size: 16.5px;
}
.pad {
  padding: 96px 0;
}
.pad.alt {
  background: linear-gradient(
    180deg,
    transparent,
    rgba(255, 255, 255, 0.5),
    transparent
  );
}
@media (max-width: 880px) {
  .pad {
    padding: 64px 0;
  }
}

/* ---------- feature band ---------- */
.band {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}
.band.rev .band-media {
  order: -1;
}
@media (max-width: 880px) {
  .band {
    grid-template-columns: 1fr;
    gap: 32px;
  }
  .band.rev .band-media {
    order: 0;
  }
}
.band h3 {
  font-size: clamp(24px, 3.4vw, 32px);
  margin: 16px 0 14px;
}
.band p {
  color: var(--muted);
  font-size: 16px;
  margin-bottom: 22px;
}
.ticks {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ticks li {
  display: flex;
  gap: 11px;
  align-items: flex-start;
  font-size: 15px;
}
.ticks .tk {
  width: 22px;
  height: 22px;
  border-radius: 7px;
  background: var(--slate-soft);
  color: var(--slate-deep);
  display: grid;
  place-items: center;
  flex: none;
  margin-top: 1px;
}
.media-card {
  background: var(--card);
  border: 1px solid var(--brd);
  border-radius: var(--radius);
  padding: 30px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 50px -28px rgba(30, 41, 59, 0.28);
}
.media-card .mglow {
  position: absolute;
  top: -40%;
  right: -20%;
  width: 380px;
  height: 380px;
  background: radial-gradient(
    closest-side,
    rgba(100, 116, 139, 0.12),
    transparent
  );
  pointer-events: none;
}

/* 微休息演示（与 App 微休息层同为翠绿系） */
.rest-demo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 18px 0;
}
.rest-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(
    closest-side,
    rgba(5, 150, 105, 0.18),
    rgba(5, 150, 105, 0.04)
  );
  display: grid;
  place-items: center;
  border: 1px solid rgba(5, 150, 105, 0.3);
  position: relative;
}
.rest-circle .cd {
  font-size: 34px;
  font-weight: 800;
  color: var(--emerald);
}
.rest-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid rgba(5, 150, 105, 0.32);
  animation: landing-pulse 3s ease-in-out infinite;
}
@keyframes landing-pulse {
  0%,
  100% {
    transform: scale(0.86);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.04);
    opacity: 0;
  }
}
.rest-demo .lbl {
  font-weight: 700;
  font-size: 15px;
}
.rest-demo .sub {
  font-size: 13px;
  color: var(--faint);
}
.timeline {
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
  margin-top: 6px;
}
.timeline .seg {
  height: 8px;
  border-radius: 6px;
  flex: 1;
  background: rgba(15, 23, 42, 0.08);
  position: relative;
}
.timeline .seg.work {
  background: linear-gradient(90deg, rgba(217, 119, 6, 0.5), var(--amber-deep));
}
.timeline .ping {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--emerald);
  box-shadow: 0 0 10px rgba(5, 150, 105, 0.6);
  margin: 0 -2px;
  z-index: 2;
}

/* ---------- feature grid ---------- */
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
@media (max-width: 880px) {
  .grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 560px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
.card {
  background: var(--card);
  border: 1px solid var(--brd);
  border-radius: var(--radius);
  padding: 26px;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 10px 30px -22px rgba(30, 41, 59, 0.3);
}
.card:hover {
  transform: translateY(-4px);
  border-color: rgba(100, 116, 139, 0.6);
  box-shadow: 0 22px 44px -24px rgba(71, 85, 105, 0.45);
}
.card .ico {
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: grid;
  place-items: center;
  background: var(--slate-soft);
  color: var(--slate-deep);
  margin-bottom: 18px;
}
.card h4 {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 9px;
}
.card p {
  font-size: 14.5px;
  color: var(--muted);
}

/* ---------- profiles ---------- */
.profiles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}
@media (max-width: 780px) {
  .profiles {
    grid-template-columns: 1fr;
  }
}
.pf-card {
  border: 1px solid var(--brd);
  border-radius: var(--radius);
  padding: 26px;
  background: var(--card);
  box-shadow: 0 10px 30px -22px rgba(30, 41, 59, 0.3);
}
.pf-card .tagk {
  font-size: 12px;
  font-weight: 700;
  padding: 5px 11px;
  border-radius: 999px;
  display: inline-block;
  margin-bottom: 16px;
}
.tagk.strong {
  background: rgba(5, 150, 105, 0.12);
  color: var(--emerald);
  border: 1px solid rgba(5, 150, 105, 0.3);
}
.tagk.soft {
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
  border: 1px solid rgba(59, 130, 246, 0.3);
}
.tagk.counter {
  background: var(--amber-soft);
  color: var(--amber-deep);
  border: 1px solid rgba(245, 158, 11, 0.32);
}
.pf-card h4 {
  font-size: 20px;
  margin-bottom: 10px;
}
.pf-card p {
  font-size: 14px;
  color: var(--muted);
}
.pf-card .rng {
  margin-top: 16px;
  font-size: 13px;
  color: var(--slate-deep);
  font-weight: 700;
}

/* ---------- heatmap（同 App 统计页的琥珀热力图） ---------- */
.heat {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 7px;
  max-width: 330px;
}
.heat .cell {
  aspect-ratio: 1;
  border-radius: 7px;
  background: rgba(15, 23, 42, 0.05);
}
.stat-row {
  display: flex;
  gap: 30px;
  margin-top: 26px;
  flex-wrap: wrap;
}
.stat-row .s b {
  font-size: 28px;
  font-weight: 800;
  color: var(--amber-deep);
  display: block;
}
.stat-row .s span {
  font-size: 12.5px;
  color: var(--faint);
  font-weight: 600;
}

/* share card mini —— 成绩单实卡为深色，与 App 分享卡一致 */
.share-mini {
  width: 215px;
  margin: 0 auto;
  border-radius: 20px;
  background: linear-gradient(180deg, #1b2030, #0e111b);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 22px 18px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 26px 54px -24px rgba(30, 41, 59, 0.5);
}
.share-mini .sglow {
  position: absolute;
  top: -30%;
  left: 50%;
  transform: translateX(-50%);
  width: 75%;
  height: 40%;
  background: radial-gradient(closest-side, rgba(245, 158, 11, 0.2), transparent);
}
.share-mini .zn {
  color: var(--amber);
  font-weight: 800;
  letter-spacing: 0.25em;
  font-size: 14px;
}
.share-mini .slo {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 14px;
}
.share-mini .big {
  font-size: 40px;
  font-weight: 800;
  color: var(--amber-lt);
}
.share-mini .biglbl {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.62);
  margin-bottom: 14px;
}
.share-mini .mini-rows {
  text-align: left;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.62);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 12px;
}
.share-mini .mini-rows .r {
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
}
.share-mini .mini-rows .r b {
  color: var(--amber-lt);
}

/* ---------- platforms ---------- */
.plats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}
@media (max-width: 780px) {
  .plats {
    grid-template-columns: 1fr 1fr;
  }
}
.plat {
  text-align: center;
  padding: 30px 18px;
  border: 1px solid var(--brd);
  border-radius: var(--radius);
  background: var(--card);
  box-shadow: 0 10px 30px -22px rgba(30, 41, 59, 0.3);
}
.plat .pic {
  width: 54px;
  height: 54px;
  border-radius: 15px;
  display: grid;
  place-items: center;
  margin: 0 auto 14px;
  background: var(--slate-soft);
  color: var(--slate-deep);
}
.plat .pic svg {
  margin: 0 auto;
}
.plat b {
  display: block;
  font-size: 16px;
  margin-bottom: 4px;
}
.plat span {
  font-size: 13px;
  color: var(--faint);
}

/* ---------- pricing ---------- */
.price-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 1060px;
  margin: 0 auto;
  align-items: stretch;
}
@media (max-width: 920px) {
  .price-wrap {
    grid-template-columns: 1fr;
    max-width: 440px;
  }
}
.price {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--brd);
  border-radius: 24px;
  padding: 34px;
  background: #fff;
  position: relative;
  box-shadow: 0 14px 40px -26px rgba(30, 41, 59, 0.3);
  text-align: left;
}
.price .badge {
  display: inline-block;
  align-self: flex-start;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.05);
  color: var(--muted);
  border: 1px solid var(--brd);
  margin-bottom: 14px;
}
.price.pro {
  border-color: rgba(245, 158, 11, 0.55);
  background: linear-gradient(170deg, #fffaf0, #ffffff);
  box-shadow: 0 30px 60px -28px rgba(245, 158, 11, 0.5);
}
.price .pname {
  font-size: 18px;
  font-weight: 800;
  color: var(--amber-deep);
}
.price .pp {
  font-size: 42px;
  font-weight: 800;
  margin: 12px 0 4px;
  color: var(--ink);
}
.price .pp small {
  font-size: 15px;
  color: var(--faint);
  font-weight: 600;
}
.price .psub {
  font-size: 13px;
  color: var(--faint);
  margin-bottom: 22px;
}
.price ul {
  flex: 1;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 13px;
  margin-bottom: 26px;
}
.price li {
  display: flex;
  gap: 10px;
  font-size: 14.5px;
  color: var(--muted);
}
.price li .tk {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background: var(--slate-soft);
  color: var(--slate-deep);
  display: grid;
  place-items: center;
  flex: none;
}
.price.pro li .tk {
  background: var(--amber-soft);
  color: var(--amber-deep);
}
.ribbon {
  position: absolute;
  top: 22px;
  right: 22px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
  color: #3d2600;
  background: linear-gradient(180deg, var(--amber-lt), var(--amber));
  padding: 5px 11px;
  border-radius: 999px;
}

/* ---------- CTA ---------- */
.cta-final {
  text-align: center;
  border: 1px solid var(--brd);
  border-radius: 32px;
  padding: 64px 30px;
  background: var(--card);
  position: relative;
  overflow: hidden;
  box-shadow: 0 30px 70px -34px rgba(71, 85, 105, 0.5);
}
.cta-final .cglow {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    closest-side at 50% 0%,
    rgba(100, 116, 139, 0.14),
    transparent
  );
}
.cta-final h2 {
  font-size: clamp(28px, 4.4vw, 46px);
  margin-bottom: 16px;
  position: relative;
}
.cta-final p {
  color: var(--muted);
  font-size: 17px;
  margin-bottom: 30px;
  position: relative;
}
.cta-btns {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
}

/* ---------- footer ---------- */
footer {
  border-top: 1px solid rgba(15, 23, 42, 0.08);
  padding: 48px 0 40px;
  margin-top: 30px;
}
.foot {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  flex-wrap: wrap;
}
.foot .col {
  display: flex;
  flex-direction: column;
  gap: 11px;
}
.foot .brand-col {
  max-width: 280px;
}
.brand-desc {
  font-size: 13.5px;
  color: var(--faint);
}
.foot .col a {
  font-size: 14px;
  color: var(--muted);
}
.foot .col a:hover {
  color: var(--ink);
}
.foot .col .ht {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--faint);
  margin-bottom: 4px;
}
.copyright {
  margin-top: 36px;
  padding-top: 24px;
  border-top: 1px solid rgba(15, 23, 42, 0.07);
  font-size: 13px;
  color: var(--faint);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

/* ---------- 深浅切换按钮 ---------- */
.theme-toggle {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: var(--muted);
  background: var(--card);
  border: 1px solid var(--brd);
  transition: color 0.2s, background 0.2s, transform 0.15s;
}
.theme-toggle:hover {
  color: var(--ink);
  transform: translateY(-1px);
}

/* ============================================================
   深色主页（还原原 site/index.html 暗色版）
   通过重映射强调令牌把「石板」换成「琥珀」，并覆盖少量硬编码浅色，
   布局完全复用，只切换配色。
   ============================================================ */
.landing.theme-dark {
  --bg: #0a0d15;
  --card: linear-gradient(170deg, #1b2030, #0c0f18);
  --brd: rgba(255, 255, 255, 0.1);
  --ink: #f4f6fb;
  --muted: rgba(244, 246, 251, 0.62);
  --faint: rgba(244, 246, 251, 0.4);
  /* 深色版强调色为琥珀：把 slate 令牌整体映射到 amber，
     eyebrow / 勾选块 / 图标底 / 数据数字等随之变琥珀 */
  --slate: #fbbf24;
  --slate-deep: #fbbf24;
  --slate-soft: rgba(245, 158, 11, 0.14);
  --amber-deep: #fbbf24;
}
.landing.theme-dark {
  background: var(--bg);
}
.landing.theme-dark header {
  background: rgba(10, 13, 21, 0.72);
  border-bottom-color: rgba(255, 255, 255, 0.06);
}
.landing.theme-dark .eyebrow {
  border-color: rgba(245, 158, 11, 0.25);
}
.landing.theme-dark .eyebrow .dot {
  box-shadow: 0 0 10px var(--amber-lt);
}
.landing.theme-dark .grad-text {
  background: linear-gradient(120deg, #fff 20%, var(--amber-lt) 75%, var(--amber));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.landing.theme-dark .btn-primary {
  background: linear-gradient(180deg, var(--amber-lt), var(--amber));
  color: #241600;
  box-shadow: 0 10px 30px -8px rgba(245, 158, 11, 0.5);
}
.landing.theme-dark .btn-primary:hover {
  background: linear-gradient(180deg, #fcd34d, var(--amber-lt));
  box-shadow: 0 16px 40px -8px rgba(245, 158, 11, 0.65);
}
.landing.theme-dark .btn-ghost {
  background: rgba(255, 255, 255, 0.06);
  color: var(--ink);
  border-color: var(--brd);
}
.landing.theme-dark .btn-ghost:hover {
  background: rgba(255, 255, 255, 0.12);
}
.landing.theme-dark .logo {
  box-shadow: 0 0 22px -4px rgba(245, 158, 11, 0.5);
}
.landing.theme-dark .hero-glow {
  background: radial-gradient(
    closest-side,
    rgba(245, 158, 11, 0.18),
    rgba(245, 158, 11, 0)
  );
}
.landing.theme-dark .phone {
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 40px 90px -30px rgba(0, 0, 0, 0.8),
    0 0 0 6px rgba(255, 255, 255, 0.02), inset 0 0 0 1px rgba(255, 255, 255, 0.03);
}
.landing.theme-dark .phone .glow {
  background: radial-gradient(
    closest-side,
    rgba(245, 158, 11, 0.22),
    transparent
  );
}
.landing.theme-dark .phone .tag-pill {
  border-color: rgba(255, 255, 255, 0.18);
}
.landing.theme-dark .phone .top-ic {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(244, 246, 251, 0.45);
}
.landing.theme-dark .phone .start-btn {
  background: linear-gradient(180deg, var(--amber-lt), var(--amber));
  color: #241600;
  box-shadow: 0 14px 30px -10px rgba(245, 158, 11, 0.55);
}
.landing.theme-dark .float-card {
  background: rgba(20, 24, 34, 0.9);
  border-color: var(--brd);
}
.landing.theme-dark .float-card .ic-amber {
  background: rgba(245, 158, 11, 0.16);
  color: var(--amber-lt);
}
.landing.theme-dark .strip {
  border-color: rgba(255, 255, 255, 0.06);
}
.landing.theme-dark .card:hover {
  border-color: rgba(245, 158, 11, 0.5);
  box-shadow: 0 22px 44px -24px rgba(245, 158, 11, 0.4);
}
.landing.theme-dark .media-card .mglow {
  background: radial-gradient(
    closest-side,
    rgba(245, 158, 11, 0.12),
    transparent
  );
}
.landing.theme-dark .timeline .seg {
  background: rgba(255, 255, 255, 0.08);
}
.landing.theme-dark .timeline .seg.work {
  background: linear-gradient(90deg, rgba(245, 158, 11, 0.5), var(--amber));
}
.landing.theme-dark .tagk.soft {
  background: rgba(59, 130, 246, 0.15);
  color: #93c5fd;
  border-color: rgba(59, 130, 246, 0.35);
}
.landing.theme-dark .heat .cell {
  background: rgba(255, 255, 255, 0.05);
}
.landing.theme-dark .price {
  background: rgba(255, 255, 255, 0.03);
}
.landing.theme-dark .price.pro {
  background: linear-gradient(
    170deg,
    rgba(245, 158, 11, 0.1),
    rgba(255, 255, 255, 0.02)
  );
  border-color: rgba(245, 158, 11, 0.45);
  box-shadow: 0 30px 60px -28px rgba(245, 158, 11, 0.45);
}
.landing.theme-dark .price .badge {
  background: rgba(255, 255, 255, 0.05);
  border-color: var(--brd);
}
.landing.theme-dark .cta-final {
  background: var(--card);
  border-color: rgba(245, 158, 11, 0.35);
  box-shadow: 0 30px 70px -34px rgba(245, 158, 11, 0.4);
}
.landing.theme-dark .cta-final .cglow {
  background: radial-gradient(
    closest-side at 50% 0%,
    rgba(245, 158, 11, 0.16),
    transparent
  );
}
.landing.theme-dark footer {
  border-top-color: rgba(255, 255, 255, 0.08);
}
.landing.theme-dark .copyright {
  border-top-color: rgba(255, 255, 255, 0.07);
}
</style>
